import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/Spinner";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();

  if (loading) return <FullScreenLoader label="Checking session…" />;
  if (!user) return <Navigate to="/login" replace />;

  if (role && user.role !== role) {
    const home = user.role === "admin" ? "/admin/dashboard" : "/worker/map";
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center" data-testid="unauthorized-screen">
        <ShieldAlert className="h-12 w-12 text-orange-500" strokeWidth={2} />
        <h1 className="text-2xl font-bold font-heading">Unauthorized access</h1>
        <p className="max-w-sm text-stone-500">
          You don't have permission to view this page with your current role.
        </p>
        <Button data-testid="go-home-btn" onClick={() => (window.location.href = home)}>
          Go to my dashboard
        </Button>
      </div>
    );
  }

  return children;
}
